export default class CreateDepartmentRequest  {
	name: string;  
    arrivalInstructions = '';
}